import React from 'react'
import { ReactComponent } from './Assignment.svg'
import { MergeReactElementProps } from '../types'

interface AssignmentProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', AssignmentProps>

export const Assignment = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent stroke={color} ref={ref} {...props} />
  }
)
